import { Environment } from 'signup-ui-lego-core/constants/Environment';
import { Language } from 'signup-ui-lego-core/constants/Language';
import * as MessageTypes from './constants/MessageTypes';
import { SignupEmbedder } from './SignupEmbedder';
import { SignupEmbedderOptions } from './SignupEmbedderOptions';
import { SignupIntegrationModalEmbedder } from './SignupIntegrationModalEmbedder';
const w = window;
w.SignupEmbedder = SignupEmbedder;
w.SignupEmbedderOptions = SignupEmbedderOptions;
w.SignupEmbedderMessageTypes = MessageTypes;
w.SignupEmbedderEnvironments = Environment;
w.SignupEmbedderLanguages = Language;
w.SignupIntegrationModalEmbedder = SignupIntegrationModalEmbedder;
export { SignupEmbedder } from './SignupEmbedder';
export { SignupEmbedderOptions } from './SignupEmbedderOptions';
export { SignupIntegrationModalEmbedder } from './SignupIntegrationModalEmbedder';